module.exports = __webpack_public_path__ + "img/like.12aa6e5b.svg";